import { Component, OnInit, ViewChild } from '@angular/core';
import { HangfireBeheerService } from '../services/hangfire-beheer.service';
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators
} from '@angular/forms';
import { HangfireJob } from '../models/hangfire-job';
import { genericSortingAccessor } from '../shared.module';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-beheer-taken',
  templateUrl: './beheer-taken.component.html',
  styleUrls: ['./beheer-taken.component.scss']
})
export class BeheerTakenComponent implements OnInit {
  beschikbareTaken: string[];
  nieuweTaakForm: UntypedFormGroup = this.fb.group({
    id: [''],
    cron: [''],
    argument: [''],
    type: ['']
  });

  public isLoading: boolean = false;
  public isToevoegenActief: boolean = false;

  dataSource = new MatTableDataSource<HangfireJob>();
  displayedColumns: string[] = [
    'id',
    'cron',
    'jobArgument',
    'jobType',
    'acties'
  ];

  @ViewChild(MatSort, { static: false }) sort: MatSort;

  constructor(
    private hangfireSvc: HangfireBeheerService,
    private fb: UntypedFormBuilder,
    private snackBar: MatSnackBar
  ) {}

  ngOnInit() {
    this.resetNieuweTaakForm();

    this.hangfireSvc.beschikbareTaken().subscribe((t) => {
      this.beschikbareTaken = t;
    });

    this.ladenJobs();
  }

  ladenJobs() {
    this.isLoading = true;

    this.hangfireSvc.load().subscribe(
      (data) => {
        this.dataSource.data = data;
        this.dataSource.sort = this.sort;
        this.dataSource.sortingDataAccessor = genericSortingAccessor;

        this.isLoading = false;
      },
      (error) => {
        this.showToast('Fout bij het ophalen van de taken.');
        this.isLoading = false;
      }
    );
  }

  resetNieuweTaakForm() {
    this.nieuweTaakForm = this.fb.group({
      id: ['', [Validators.required]],
      cron: ['* * * * *'],
      argument: ['10000'],
      type: [null, [Validators.required]]
    });
  }

  TaakToevoegen() {
    if (!this.nieuweTaakForm.value.id) {
      alert('Vul een id in');
      return;
    }

    if (!this.nieuweTaakForm.value.type) {
      alert('Kies een type taak');
      return;
    }

    this.isToevoegenActief = true;

    let hfj: HangfireJob = {
      id: this.nieuweTaakForm.value.id,
      cron: this.nieuweTaakForm.value.cron,
      jobArgument: this.nieuweTaakForm.value.argument,
      jobType: this.nieuweTaakForm.value.type
    };

    this.hangfireSvc.toevoegenTaak(hfj).subscribe(
      (h) => {
        this.isToevoegenActief = false;

        this.resetNieuweTaakForm();
        this.ladenJobs();
      },
      (error) => {
        this.showToast('Fout bij het toevoegen van de taak');
        this.isToevoegenActief = false;
      }
    );
  }

  TaakVerwijderen(hfj: HangfireJob) {
    let akkoord = confirm(`Job ${hfj.id} verwijderen?`);

    if (akkoord) {
      this.hangfireSvc.verwijderenTaak(hfj).subscribe((h) => {
        this.ladenJobs();
      });
    }
  }

  showToast(tekst: string) {
    this.snackBar.open(tekst, null, { duration: 3000 });
  }
}
